module.exports = __webpack_public_path__ + "res/landing_a_en.50da86bc9b03bf78ed5b0836fac984c0.mp4";